<template lang="pug">
  .box.box-primary(:data-testid="'-content-office-' + officeNo")
    .box-header.with-border(role="tab", :class="'jbcard-card-heading-' + officeNo")
      h4.box-title
        a(class="collapsed", role="button", data-toggle="collapse", data-parent=".jbcard-card-accordion", :href="'.jbcard-card-collapse-' + officeNo", :aria-controls="'jbcard-card-collapse-' + officeNo" data-testid="-link-card-accordion") 事業所{{officeNo}}
          |
          |
          i.fa.fa-sort

    .panel-collapse.collapse(:class="'jbcard-card-collapse-' + officeNo", role="tabpanel", :aria-labelledby="'jbcard-card-heading-' + officeNo")
      .box-body
        .row
          .form-group.col-sm-12
            label 事業所
            p.form-control-static(data-testid="-info-office-name") {{officeInfo.office_name}}
        .row
          .form-group.col-sm-12
            label 住所
            template(v-if="officeInfo.zipcode || officeInfo.address1 || officeInfo.address2")
              p.form-control-static(v-if="officeInfo.zipcode" data-testid="-info-office-zipcode") 〒{{officeInfo.zipcode}}
              p.form-control-static: address-link(:addresses="[officeInfo.address1, officeInfo.address2]" data-testid="-info-office-address")
            p.form-control-static(v-else)
        .row
          .form-group.col-sm-12
            label 電話番号1
            p.form-control-static(data-testid="-info-office-tel1") {{officeInfo.tel1}}
        .row
          .form-group.col-sm-12
            label 電話番号1内線
            p.form-control-static(data-testid="-info-office-naisen1") {{officeInfo.naisen1}}
        .row
          .form-group.col-sm-12
            label 電話番号2
            p.form-control-static(data-testid="-info-office-tel2") {{officeInfo.tel2}}
        .row
          .form-group.col-sm-12
            label 電話番号2内線
            p.form-control-static(data-testid="-info-office-naisen2") {{officeInfo.naisen2}}
        .row
          .form-group.col-sm-12
            label 携帯電話
            p.form-control-static(data-testid="-info-office-mobile") {{officeInfo.mobile}}
        .row
          .form-group.col-sm-12
            label FAX
            p.form-control-static(data-testid="-info-office-fax") {{officeInfo.fax}}
        .row
          .form-group.col-sm-12
            label メールアドレス
            p.form-control-static: a(:href="'mailto:' + officeInfo.mail" data-testid="-info-office-mail") {{officeInfo.mail}}
        .row
          .form-group.col-xs-12
            label URL
            p.form-control-static: a(:href="officeInfo.valid_url", target="_blank" data-testid="-info-office-url") {{officeInfo.url}}
</template>

<script>
import AddressLink from '@/components/molecules/AddressLink'

export default {
  name: 'OfficeAccordion',
  components: { AddressLink },
  props: {
    officeNo: {type: String, required: true},
    officeInfo: {type: Object, required: true}
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalLatestBcardOffice.vue